<ion-button class="add-route-icon" (click)="clickAddRoute()">
  <ion-icon slot="start" src="assets/RouteAdd.svg" alt="add route"></ion-icon>
  <ion-text class="add-text" slot="end">
    {{ CONSTS.ADD_ROUTE }}
  </ion-text>
</ion-button>
